// const aepCjaConstultantQ = {
//     topic: 'Aep Cja Consultant',
//     questions: [
//         {
//             label: 'Data Ingestion and Preparation',
//             question:
//                 'When preparing data for ingestion into Adobe Customer Journey Analytics, what is the most critical step to ensure data consistency and accuracy?',
//             choices: [
//                 'Transforming all data into a single file format',
//                 'Ensuring all data sources are mapped to the Experience Data Model (XDM) schema',
//                 'Ingesting data without any preprocessing',
//                 'Using third-party tools for data transformation'
//             ],
//             type: 'MCQs',
//             correctAnswer: 'Ensuring all data sources are mapped to the Experience Data Model (XDM) schema',
//         },
//     ]
// }

const aepCjaConstultantQ = {
    topic: 'Aep Cja Consultant',
    questions: [
        {
            label: 'Data Ingestion and Preparation',
            question:
                'When preparing data for ingestion into Adobe Customer Journey Analytics, what is the most critical step to ensure data consistency and accuracy?',
            choices: [
                'Transforming all data into a single file format',
                'Ensuring all data sources are mapped to the Experience Data Model (XDM) schema',
                'Ingesting data without any preprocessing',
                'Using third-party tools for data transformation'
            ],
            type: 'MCQs',
            correctAnswer: 'Ensuring all data sources are mapped to the Experience Data Model (XDM) schema',
        },
        {
            label: 'Identity Resolution',
            question:
                'Which method is recommended for resolving customer identities across different data sources in Adobe Customer Journey Analytics?',
            choices: [
                'Deterministic matching only',
                'Probabilistic matching only',
                'A combination of deterministic and probabilistic matching',
                'Manual matching by data analysts'
            ],
            type: 'MCQs',
            correctAnswer: 'A combination of deterministic and probabilistic matching',
        },
        {
            label: 'Data Views and Filters',
            question:
                'What is the primary purpose of using filters in Adobe Customer Journey Analytics?',
            choices: [
                'To permanently delete irrelevant data from the dataset',
                'To segment and analyze subsets of data without modifying the original dataset',
                'To convert data into different formats',
                'To combine multiple datasets into one'
            ],
            type: 'MCQs',
            correctAnswer: 'To segment and analyze subsets of data without modifying the original dataset',
        },
        {
            label: 'Visualizations and Dashboards',
            question:
                'Which visualization type in Adobe Customer Journey Analytics is most suitable for analyzing the sequential steps a customer takes in their journey?',
            choices: [
                'Bar Chart',
                'Pie Chart',
                'Flow Analysis',
                'Scatter Plot'
            ],
            type: 'MCQs',
            correctAnswer: 'Flow Analysis',
        },
        {
            label: 'Attribution Models',
            question:
                'Which attribution model would you use in Adobe Customer Journey Analytics to give credit to all touchpoints in a customer’s journey equally?',
            choices: [
                'Last Touch',
                'First Touch',
                'Linear Attribution',
                'Time Decay'
            ],
            type: 'MCQs',
            correctAnswer: 'Linear Attribution',
        },
        {
            label: 'Real-Time Data Processing',
            question:
                'How does Adobe Customer Journey Analytics handle real-time data processing for immediate insights?',
            choices: [
                'By processing data in hourly batches',
                'By using in-memory databases to process data as it arrives',
                'By delaying data processing to reduce system load',
                'By relying on daily data syncs'
            ],
            type: 'MCQs',
            correctAnswer: 'By using in-memory databases to process data as it arrives',
        },
        {
            label: 'Data Governance and Compliance',
            question:
                'What feature in Adobe Customer Journey Analytics ensures data governance and compliance with regulations such as GDPR?',
            choices: [
                'Unencrypted data storage',
                'Manual compliance checks',
                'Automated data classification and policy enforcement',
                'Disabling user access to sensitive data'
            ],
            type: 'MCQs',
            correctAnswer: 'Automated data classification and policy enforcement',
        },
        {
            label: 'Advanced Segmentation',
            question:
                'Which feature in Adobe Customer Journey Analytics allows you to create complex audience segments based on multiple criteria and conditions?',
            choices: [
                'Basic Filters',
                'Segment Builder',
                'Data Views',
                'Report Suites'
            ],
            type: 'MCQs',
            correctAnswer: 'Segment Builder',
        },
        {
            label: 'Integration with Adobe Experience Platform',
            question:
                'What is the main advantage of integrating Adobe Customer Journey Analytics with Adobe Experience Platform?',
            choices: [
                'Simplified data storage',
                'Enhanced real-time data synchronization and unified customer profiles',
                'Reduced data processing costs',
                'Elimination of data transformation needs'
            ],
            type: 'MCQs',
            correctAnswer: 'Enhanced real-time data synchronization and unified customer profiles',
        },
        {
            label: 'Custom Calculations',
            question:
                'In Adobe Customer Journey Analytics, how can you create a custom metric to calculate the average time between customer interactions?',
            choices: [
                'Using predefined metrics only',
                'Creating a new metric with custom calculations in the Analysis Workspace',
                'Manually calculating it outside the platform',
                'Using default time-based metrics'
            ],
            type: 'MCQs',
            correctAnswer: 'Creating a new metric with custom calculations in the Analysis Workspace',
        },
        {
            label: 'Troubleshooting Data Discrepancies',
            question:
                'What is the first step in troubleshooting data discrepancies in Adobe Customer Journey Analytics?',
            choices: [
                'Deleting the affected data',
                'Verifying data mappings to XDM schemas',
                'Reingesting all data',
                'Ignoring the discrepancies'
            ],
            type: 'MCQs',
            correctAnswer: 'Verifying data mappings to XDM schemas',
        },
        {
            label: 'Use Case Implementation',
            question:
                'For a use case requiring the analysis of customer churn, which combination of features in Adobe Customer Journey Analytics would be most effective?',
            choices: [
                'Flow Analysis and Linear Attribution',
                'Segment Builder and Predictive Analytics',
                'Data Views and Basic Filters',
                'Report Suites and Time Decay Attribution'
            ],
            type: 'MCQs',
            correctAnswer: 'Segment Builder and Predictive Analytics',
        },
        {
            label: 'Data Sources Integration',
            question:
                'When integrating multiple data sources into Adobe Customer Journey Analytics, what is a best practice to ensure data quality?',
            choices: [
                'Avoiding any data transformation',
                'Consistently applying data cleansing and validation rules',
                'Using only one data source at a time',
                'Ignoring data discrepancies'
            ],
            type: 'MCQs',
            correctAnswer: 'Consistently applying data cleansing and validation rules',
        },
        {
            label: 'Advanced Reporting',
            question:
                'Which reporting feature in Adobe Customer Journey Analytics allows you to schedule and automate report distribution?',
            choices: [
                'Static Reports',
                'Dynamic Dashboards',
                'Scheduled Reports',
                'Ad Hoc Analysis'
            ],
            type: 'MCQs',
            correctAnswer: 'Scheduled Reports',
        },
        {
            label: 'API Usage',
            question:
                'What is the primary use of APIs in Adobe Customer Journey Analytics?',
            choices: [
                'To manually enter data',
                'To automate data ingestion, retrieval, and integration with other systems',
                'To create static reports',
                'To disable data processing'
            ],
            type: 'MCQs',
            correctAnswer: 'To automate data ingestion, retrieval, and integration with other systems',
        },
        {
            label: 'Scenario: Data Integration Challenge',
            question:
                'Your company has integrated multiple data sources into Adobe Customer Journey Analytics. However, you notice discrepancies in the customer profiles, where some profiles are duplicated or incomplete. What steps would you take to identify and resolve these issues?',
            choices: [
                'Ignore the discrepancies and proceed with analysis',
                'Reingest all data without any changes',
                'Verify data mappings to XDM schemas, use identity resolution to merge duplicates, and ensure all data sources are correctly linked',
                'Manually edit each customer profile to correct the discrepancies'
            ],
            correctAnswer:
                'Verify data mappings to XDM schemas, use identity resolution to merge duplicates, and ensure all data sources are correctly linked',
        },
        {
            label: 'Scenario: Campaign Performance Analysis',
            question:
                'A client wants to analyze the performance of their recent marketing campaign across multiple channels (email, social media, and web). They are particularly interested in understanding the sequence of customer interactions that led to conversions. How would you set up this analysis in Adobe Customer Journey Analytics?',
            choices: [
                'Use basic filters to segment the data',
                'Set up a Flow Analysis to visualize the sequence of customer interactions across channels',
                'Rely solely on predefined reports',
                'Manually track customer interactions across different datasets'
            ],
            correctAnswer:
                'Set up a Flow Analysis to visualize the sequence of customer interactions across channels',
        },
        {
            label: 'Scenario: Real-Time Personalization',
            question:
                'A retail company wants to implement real-time personalization on their website based on customer behavior. They plan to use Adobe Customer Journey Analytics to achieve this. What steps would you recommend to set up real-time personalization?',
            choices: [
                'Use static customer profiles updated monthly',
                'Integrate real-time data streams into Adobe Experience Platform, update Real-time Customer Profiles dynamically, and use this data for personalization',
                'Wait for daily data syncs to update profiles',
                'Manually update customer profiles based on recent interactions'
            ],
            correctAnswer:
                'Integrate real-time data streams into Adobe Experience Platform, update Real-time Customer Profiles dynamically, and use this data for personalization',
        },
        {
            label: 'Scenario: GDPR Compliance',
            question:
                'Your organization needs to ensure GDPR compliance for customer data stored and processed in Adobe Customer Journey Analytics. What measures would you implement to adhere to GDPR regulations?',
            choices: [
                'Store all data in plain text for easy access',
                'Implement automated data classification, anonymization, and pseudonymization, and enforce role-based access control (RBAC)',
                'Ignore GDPR requirements and focus on data analysis',
                'Rely on manual data checks for compliance'
            ],
            correctAnswer:
                'Implement automated data classification, anonymization, and pseudonymization, and enforce role-based access control (RBAC)',
        },
        {
            label: 'Scenario: Customer Churn Prediction',
            question:
                'A subscription-based service provider wants to predict customer churn using Adobe Customer Journey Analytics. What combination of features and approaches would you use to build a predictive model for churn?',
            choices: [
                'Use only historical transaction data',
                'Combine behavioral data, historical data, and apply machine learning models in the Data Science Workspace',
                'Rely on predefined churn metrics without customization',
                'Use basic descriptive statistics in Excel'
            ],
            correctAnswer:
                'Combine behavioral data, historical data, and apply machine learning models in the Data Science Workspace',
        }
    ]
};

export default aepCjaConstultantQ;
